//my-web-app/src/utils/api.ts

// utils/api.ts
// import { useEffect, useState } from 'react';
import axios, { InternalAxiosRequestConfig } from 'axios';
import { Brand, Category, Product, appConfig, Customer, Modifier } from './types';
import { setAuthToken, hasRole, isAuthenticated } from './auth';
// import { getConfig } from '../config/configLoader';
import { AxiosResponse } from 'axios'; // Import AxiosResponse type
import { ApiCountry, ApiState, ApiCity, User, TaskReminder } from './types'; // Ensure appConfig is imported
import { v4 as uuidv4 } from 'uuid'; // Import uuid
import { OrderItem } from './types'; // For fetchSoftDeletedOrderItems potentially
import { getAuthToken } from './auth'; // Import getAuthToken
import { use } from 'i18next';

// Accessing the API URL from environment variables

// Type-safe access
const API_URL = window.APP_CONFIG?.API_URL;
const DOMAIN_URL = window.APP_CONFIG?.DOMAIN_URL;


// Create an axios instance with the base URL
export const api = axios.create({
    baseURL: API_URL,
});

// Add a request interceptor to automatically add the token to headers abb 250617
api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = getAuthToken(); // Use your existing utility

        // console.log('API Request Interceptor - URL:', config.url, 'Token:', token);

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
api.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error) => {

        // 401 means the token is rejected by Sanctum
        // if (error.response?.status === 401) {
        //     localStorage.removeItem('token');
        //     localStorage.removeItem('user');
        //     if (window.location.pathname !== '/login') {
        //         window.location.href = '/login';
        //     }
        // }
        // Check for a 403 error
        // else 
        if (error.response?.status === 403) {
            // Clear local storage and redirect to login
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = "/login"; // Force navigation
        } else if (error.response?.data?.message === "Token expired") {
            // Handle token expiration separately if needed
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = "/login"; // Force navigation
        }

        console.error('API Error:', error);
        return Promise.reject(error);
    }
);

export const checkSession = async () => {

    const userStr = localStorage.getItem('user');
    const user = userStr && userStr !== "undefined" ? JSON.parse(userStr) : {};
    // console.log('App > useEffect > user.remember_token', user.remember_token);
    // console.log('App > useEffect > user.session_id', user.session_id);
    const sessionId = user.session_id; // Retrieve the session_id from local storage
    const token = user.remember_token;
    // console.table('user', user);


    try {
        // const response = await api.get('/check-session?session_id=' + sessionId, {
        //     headers: {
        //         'X-Session-ID': sessionId,
        //     },

        if (isAuthenticated() && hasRole(['super_admin', 'staff', 'technician'])) {

            console.log('No need to checkSession');

        } else {
            // The Authorization header will be added by the interceptor if a token exists.
            const response = await api.get('/check-session', {
                // headers: { // This was removed as interceptor handles it if `token` is from getAuthToken()
                //     'Authorization': `Bearer ${token}`, // `token` here is user.remember_token, not from getAuthToken()
                // },
                params: {
                    session_id: sessionId,
                },
            });

            console.log('checkSession response', response);
            // console.log('csd');
            // console.log(hasRole(['super_admin', 'staff', 'technician']), 'CS :', new Date().toLocaleString());

        }

    } catch (error) {
        console.error('Error checking session:', error);
    }
};

//my-web-app/src/utils/api.ts
// export const appSettings = async (): Promise<appConfig> => {
export const appSettings = async (tenantId?: string | number): Promise<appConfig> => {
    // api = await initializeApiClient();

    if (!api) {
        throw new Error('API client is not initialized. Please ensure it is initialized before calling appSettings.');
    }

    // Remove cached settings to force fresh fetch
    localStorage.removeItem('settings');

    const endpoint = tenantId ? `/settings/${tenantId}` : '/settings';
    console.log('endpoint > ', endpoint);

    // Add a timestamp to the URL to ensure the browser doesn't serve a cached version
    // const response = await api.get(`/settings?version=250618&timestamp=${new Date().getTime()}&refresh=true`); // abb 250618 add &refresh=true
    const response = await api.get(`${endpoint}?version=250618&timestamp=${new Date().getTime()}&refresh=true`); // abb 250618 add &refresh=true

    const settings = response.data;
    localStorage.setItem('settings', JSON.stringify(settings));

    // console.log('settings response > ', response);

    // Now you can access the license regions
    const regions = settings.license_regions;

    if (regions) {
        // console.log('License Regions:', regions);
        // Example: Get the first region ID if regions is an array like ["219"]
        if (Array.isArray(regions) && regions.length > 0) {
            const firstRegionId = regions[0];
            console.log('First Region ID:', firstRegionId);
            // You can now use firstRegionId in your application logic
        }
    } else {
        console.log('No license regions found in settings.');
    }

    // You can also access other license details:
    // console.log('License Key:', settings.license_key);
    // console.log('License Modules:', settings.license_modules);
    // console.log('License Start Date:', settings.license_start_date);
    // console.log('License End Date:', settings.license_end_date);




    return settings;
};

// --- Fetch License Regions ---
interface LicenseData {
    key: string;
    start: string;
    ends: string;
    modules: string[];
    themes: string | null;
    regions: string[]; // Array of region IDs (as strings, e.g., "219")
}

export const getRegionsFromLicense = async (domain: string): Promise<string[]> => {
    const url = `https://u8.my/app/api/license?domain=${domain}`;
    try {
        const response = await axios.get<LicenseData>(url); // Using axios directly as it's an external, unauthenticated API

        // console.log("License data fetched:", response.data);

        return response.data.regions || [];
    } catch (error) {
        console.error("Could not fetch license data:", error);
        return [];
    }
};

// Register function for new users
// my-web-app/src/utils/api.ts

export const register = async (
    name: string,
    email: string,
    password: string,
    password_confirmation: string,
    phone: string = '', // Optional phone field
    customUrl: string, // Additional parameter
    companyName: string, // Additional parameter
) => {
    try {
        const response = await api.post('/register', {
            name,
            email,
            password,
            password_confirmation,
            phone, // Include phone in the payload
            customUrl: window.APP_CONFIG?.PUBLIC_URL || window.APP_CONFIG?.DOMAIN_URL, // Additional parameter
            companyName: window.APP_CONFIG?.REACT_APP_COMPANY_NAME || '', // Additional parameter
        });

        const token = response.data.access_token;

        if (token) {
            setAuthToken(token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
        }

        return response;

    } catch (error) {
        console.error("Registration failed:", error);
        throw error;
    }
};


// Existing login function, modified to store user data in localStorage
export const login = async (email: string, password: string) => {
    const response = await api.post('/login', { email, password });
    const token = response.data.access_token;

    const { access_token, user, customer } = response.data;

    console.log('login response data >> ', response.data);


    if (access_token) {
        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user));
        // Be careful: your API returns 'customer', store the ID specifically if needed
        localStorage.setItem('customer_id', customer?.id.toString());
    }

    if (token) {
        setAuthToken(token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('customer', JSON.stringify(response.data.customer_id));
    }

    console.log('login response > ', response);

    return response;
};

// utils/api.ts

export const sendResetLink = async (
    email: string,
    customUrl: string, // Additional parameter
    companyName: string, // Additional parameter
) => {
    const response = await api.post('/forgot-password', {
        email,
        customUrl, // Adjust as needed
        companyName, // Adjust as needed
    });
    return response;
};

export const resetPassword = async (email: string, password: string, confirmPassword: string, token: string) => {
    const response = await api.post('/reset-password', {
        email,
        password,
        password_confirmation: confirmPassword,
        token,
    });
    return response;
};


// Function to fetch user roles and permissions
export const fetchRolesPermissions = async () => {
    // Authorization header is handled by the interceptor
    const token = getAuthToken(); // Still good to check if a token is expected
    if (!token && !isAuthenticated()) throw new Error('No authentication token found for fetching roles/permissions.');

    const response = await api.get('/roles-permissions');

    // console.log('fetchRolesPermissions response:', response.data); // Optional: for debugging

    return response.data; // Ensure this matches the structure of your roles and permissions data
};

export const fetchUserById = async (userId: number | string) => {

    // Authorization header is handled by the interceptor
    const token = getAuthToken();
    if (!token && !isAuthenticated()) throw new Error('No authentication token found for fetching user by ID.');
    const response = await api.get(`/users/${userId}`);

    return response.data; // Should include .email
};

export const fetchUserByUUId = async (userUUID: string) => {

    if (!getAuthToken()) throw new Error('No authentication token found');

    // Authorization header is handled by the interceptor
    // const token = getAuthToken();
    // if (!token && !isAuthenticated()) throw new Error('No authentication token found for fetching user by ID.');

    const response = await api.get(`/users/uuid/${userUUID}`);

    // console.log('fetchUserByUUId response:', response.data); // Optional: for debugging

    return response.data; // Should include .email
};

export const searchUser = async (query: string) => {

    // Authorization header is handled by the interceptor
    const token = getAuthToken();
    if (!token && !isAuthenticated()) throw new Error('No authentication token found for searching users.');

    const response = await api.get(`users/search?query=${encodeURIComponent(query)}&unlinked=1`);


    console.log('searchUser response:', response.data); // Optional: for debugging

    return response; // Should include .email
};

// --- NEW FUNCTION abb 250425 ---
/**
 * Fetches the roles associated with a specific user ID.
 * Requires authentication token.
 * @param userId The ID of the user whose roles are to be fetched.
 * @returns Promise resolving to the user's roles data.
 */
export const fetchRolesByUserId = async (userId: number) => {
    // Authorization header is handled by the interceptor
    const token = getAuthToken();
    if (!token && !isAuthenticated()) {
        console.error('fetchRolesByUserId: No authentication token found.');
        throw new Error('No authentication token found');
    }
    // else {
    //     console.log('fetchRolesByUserId: Using token:', token); // Optional: for debugging
    // }

    try {
        // Construct the URL using the userId
        const url = `/users/${userId}/roles`;
        // const url = `/users/roles/${userId}`;

        const response = await api.get(url); // Interceptor adds token

        // console.log(`fetchRolesByUserId for user ${userId}:`, response.data);

        return response.data; // Return the roles data from the response

    } catch (error) {
        console.error(`Error fetching roles for user ${userId}:`, error);
        // Re-throw the error so the calling component can handle it
        throw error;
    }
};
// --- END NEW FUNCTION ---

// Fetch categories using the axios instance
export const fetchCategories = async (): Promise<Category[]> => {
    const response = await api.get('/categories?refresh=true'); // Use the api instance here
    // console.log('Category > ', response.data);
    localStorage.setItem('categories', JSON.stringify(response.data)); // Store categories in local storage

    return response.data; // Ensure this matches the structure of your Category type
};

// /src/utils/api.ts


export const fetchBrands = async (): Promise<Brand[]> => {
    const response = await api.get('/brands');
    return response.data;
};


// Fetch products with pagination and sorting options
export const fetchProducts = async (
    currentPage: number,
    search: string,
    categoryIds: number[] | null,
    brandIds: number[] | null,
    perPage: number,
    sort: string,
) => {
    let url = `/products2?page=${currentPage}&perPage=${perPage}&search=${search}&sort=${sort}`;

    if (categoryIds && categoryIds.length > 0) {
        url += `&category_ids=${categoryIds.join(',')}`;
    }
    if (brandIds && brandIds.length > 0) {
        url += `&brand_ids=${brandIds.join(',')}`;
    }

    // console.log('373 in api.ts categoryIds >>', categoryIds);

    // Authorization header is handled by the interceptor.
    // const config = {}; // Keep if other non-auth headers might be added later

    const response = await api.get(url); // Interceptor adds token
    // console.log(url);
    // console.log('385 in api.ts fetchProducts in api.ts >>', response);
    // Calculate total_pages using 'total' and 'perPage'
    const totalPages = Math.ceil(response.data.total / perPage);
    const totalProducts = response.data.total;

    // Extract the products
    const products = response.data.data.map((product: any) => ({
        ...product,
        MTPrice: product.MTPrice || null, // Add MTPrice if available, or default to null
    }));

    return {
        // products: response.data.data, // Assuming 'data' contains the array of products
        products, // Assuming 'data' contains the array of products
        total_pages: totalPages,      // Calculating the total number of pages
        total_products: totalProducts,      // Calculating the total number of products
    };
};


export const fetchProducts4manual = async (
    currentPage: number,
    search: string,
    categoryIds: number[] | null,
    brandIds: number[] | null,
    perPage: number,
    sort: string,
    inStockOnly?: boolean // Optional parameter to filter products that are in stock
    // active: boolean = true  // Optional parameter to filter active products
    // inactive: string || '',
) => {

    if (!getAuthToken()) throw new Error('No authentication token found');

    let url = `/prods4manual?page=${currentPage}&perPage=${perPage}&search=${search}&sort=${sort}`;

    if (categoryIds && categoryIds.length > 0) {
        url += `&category_ids=${categoryIds.join(',')}`;
    }
    if (brandIds && brandIds.length > 0) {
        url += `&brand_ids=${brandIds.join(',')}`;
    }
    if (inStockOnly) {
        url += `&inStockOnly=true`;
    }


    // Authorization header is handled by the interceptor.
    // const config = {}; // Keep if other non-auth headers might be added later


    const response = await api.get(url); // Interceptor adds token
    // console.log(url);
    // console.log('fetchProducts4manual in api.ts >>', response.data);

    // Calculate total_pages using 'total' and 'perPage'
    const totalPages = Math.ceil(response.data.total / perPage);
    const totalProducts = response.data.total;

    // Extract the products
    const products = response.data.data.map((product: any) => ({
        ...product,
        MTPrice: product.MTPrice || null, // Add MTPrice if available, or default to null
    }));

    return {
        // products: response.data.data, // Assuming 'data' contains the array of products
        products, // Assuming 'data' contains the array of products
        total_pages: totalPages,      // Calculating the total number of pages
        total_products: totalProducts,      // Calculating the total number of products
    };
};

export const fetchUsers4manual = async (
    currentPage: number,
    search: string,
    perPage: number,
    sort: string,
    // active: boolean = true  // Optional parameter to filter active products
    // inactive: string || '',
) => {

    if (!getAuthToken()) throw new Error('No authentication token found');

    let url = `/users4manual?page=${currentPage}&perPage=${perPage}&search=${search}&sort=${sort}`;

    // Authorization header is handled by the interceptor.
    // const config = {}; // Keep if other non-auth headers might be added later

    const response = await api.get(url); // Interceptor adds token
    // console.log(url);
    // console.log('fetchUsers4manual in api.ts >>', response);

    // Calculate total_pages using 'total' and 'perPage'
    const totalPages = Math.ceil(response.data.total / perPage);
    const totalUsers = response.data.total;

    // Extract the users
    const users = response.data.data.map((user: any) => ({
        ...user,
    }));

    return {
        // products: response.data.data, // Assuming 'data' contains the array of products
        users, // Assuming 'data' contains the array of products
        total_pages: totalPages,      // Calculating the total number of pages
        total_users: totalUsers,      // Calculating the total number of products
    };
};


// Function to fetch a product by its ID
export const fetchProductById = async (id: number, targetUserId?: number): Promise<Product> => {

    // Authorization header is handled by the interceptor.
    // const config = {}; // Keep if other non-auth headers might be added later

    const response = await api.get(`/product/${id}`); // Interceptor adds token

    // console.log('api.ts fetchProductById > ', id, response);

    return response.data; // Ensure this matches the structure of your Product type
};

// Function to fetch a product by its ID
export const fetchProductByUUId = async (uuid: string): Promise<Product> => {

    // Authorization header is handled by the interceptor.
    // const config = {}; // Keep if other non-auth headers might be added later
    if (!getAuthToken()) throw new Error('No authentication token found');

    const response = await api.get(`/product/uuid/${uuid}`); // Interceptor adds token
    // console.log('api.ts > ', id, response);

    // console.log('api.ts > fetchProductByUUId response:', response.data); // Optional: for debugging

    return response.data; // Ensure this matches the structure of your Product type
};

export const fetchMtPrice = async (
    productId: number,
    targetUserId?: number, // Optional: ID of the user whose price we want
    targetUserRole?: string // Optional: Role of the user whose price we want
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    // Determine user ID and role to use for the API call
    const userStr = localStorage.getItem('user');
    const userObj = userStr && userStr !== "undefined" ? JSON.parse(userStr) : {};
    const userIdToUse = targetUserId ?? userObj.id;

    // console.log('fetchMtPrice - userIdToUse:', userIdToUse, 'targetUserId:', targetUserId, 'userObj.id:', userObj.id);

    // Ensure rolesPermissions is parsed safely and default if necessary
    let roleToUse = targetUserRole;

    if (!roleToUse) {
        try {
            const rolesPermissions = JSON.parse(localStorage.getItem('rolesPermissions') || '{}');
            roleToUse = rolesPermissions?.roles?.[0]; // Get the first role of the logged-in user
        } catch (e) {
            console.error("Failed to parse rolesPermissions from localStorage", e);
            roleToUse = undefined; // Or some default role if applicable
        }
    }


    if (!userIdToUse || !roleToUse) {
        console.error("fetchMtPrice: Missing User ID or Role for price calculation.");
        throw new Error("User ID or Role missing for price calculation.");
    }

    try {
        // console.log('fetchMtPrice - userId:', userIdToUse, 'role:', roleToUse); // Debugging line

        const response = await api.get('/getmtprice', {
            // headers: { // Handled by interceptor
            //     Authorization: `Bearer ${token}`,
            // },
            params: {
                user_id: userIdToUse, // Use the determined user ID
                role: roleToUse,      // Use the determined role
                // token: token, // Token is usually sent in header, might be redundant here
                product_id: productId,
            },
        });

        // console.log(`fetchMtPrice for user ${userIdToUse}, role ${roleToUse}, product ${productId}:`, response.data);

        return response.data;
    } catch (error) {
        console.error(`Error in fetchMtPrice for user ${userIdToUse}, product ${productId}:`, error);
        throw error;
    }
};

// Function to fetch multiple mt_prices for a specific user/role and products
export const fetchAllMtPrices = async (
    productIds: number[],
    targetUserId?: number, // Optional: ID of the user whose prices we want
    targetUserRole?: string // Optional: Role of the user whose prices we want
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    // Determine user ID and role to use
    const userStr = localStorage.getItem('user');
    const userObj = userStr && userStr !== "undefined" ? JSON.parse(userStr) : {};
    const userIdToUse = targetUserId ?? userObj.id;

    let roleToUse = targetUserRole;
    if (!roleToUse) {
        try {
            const rolesPermissions = JSON.parse(localStorage.getItem('rolesPermissions') || '{}');
            roleToUse = rolesPermissions?.roles?.[0];
        } catch (e) {
            console.error("Failed to parse rolesPermissions from localStorage", e);
            roleToUse = undefined;
        }
    }

    if (!userIdToUse || !roleToUse) {
        console.error("fetchAllMtPrices: Missing User ID or Role for price calculation.");
        throw new Error("User ID or Role missing for price calculation.");
    }

    if (productIds.length === 0) {
        return []; // Return empty if no product IDs provided
    }

    try {
        const response = await api.get('/allmtprices', { // Assuming this endpoint exists and works similarly
            // headers: { // Handled by interceptor
            //     Authorization: `Bearer ${token}`,
            // },
            params: {
                user_id: userIdToUse,
                role: roleToUse,
                product_ids: productIds.join(','),
            },
        });
        // console.log(`fetchAllMtPrices for user ${userIdToUse}, role ${roleToUse}:`, response.data);
        // console.log('fetchAllMtPrices - userId:', userIdToUse, 'role:', roleToUse); // Debugging line

        return response.data;
    } catch (error) {
        console.error(`Error in fetchAllMtPrices for user ${userIdToUse}:`, error);
        throw error;
    }
};


// --- IMPORTANT ---
// Also review fetchProducts and fetchProductById. If your backend calculates and includes
// MTPrice directly in the response of these endpoints based on the authenticated user (via token),
// you might need to modify those backend endpoints AND these frontend API functions
// to accept and use targetUserId/targetUserRole similarly to fetchMtPrice.
// For now, we assume MTPrice is fetched separately or handled correctly by the backend based on the token.


// end abb 250425


// export const fetchAllMtPrices = async (productIds: number[]) => {
//     const token = localStorage.getItem('token');
//     if (!token) throw new Error('No authentication token found');

//     const response = await api.get('/allmtprices', {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//         params: {
//             product_ids: productIds.join(','), // Send multiple IDs as a comma-separated string
//         },
//     });

//     return response.data; // Adjust based on your API response structure
// };

export const uploadCsv = async (file: File) => {

    if (!getAuthToken()) throw new Error('No authentication token found');

    // const userId = JSON.parse( || '{}').id; // Get user ID from local storage
    const role = JSON.parse(localStorage.getItem('rolesPermissions') || '{}').roles[0]; // Assuming you want the first role
    // console.log('roles' ,role);

    if (role !== 'super_admin' && role !== 'staff') {
        throw new Error('You do not have permission to upload CSV files.');
    }

    const formData = new FormData();
    formData.append('csv_file', file);

    // Note: This uses a different base URL and is not using the `api` instance.
    // If it needs authentication, it won't get it from the interceptor.
    // const response = await axios.post('https://t1.u8.my/api/import-csv', formData, {
    const response = await api.post('/import-csv', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            // If this endpoint requires auth, the token needs to be added manually here
            // Authorization: `Bearer ${getAuthToken()}`
        },
    });
    return response.data;
};




export const getOrderProcessLog = async (orderId: number) => {
    // Authorization header is handled by the interceptor
    const response = await api.get(`/orders/${orderId}/process-log`);
    // console.log('getOrderProcessLog:', response);
    return response.data; // Adjust based on the API response structure
};



export const fetchOrderDetails = async (orderId: number) => {
    // Authorization header is handled by the interceptor
    const response = await api.get(`orders/${orderId}`);
    // console.log('fetchOrderDetails in api ln205:', response);

    // Map the response data to include modifiers
    const orderData = {
        ...response.data,
        items: response.data.items.map((item: any) => ({
            ...item,
            modifiers: item.modifiers || [], // Ensure modifiers is an array
        })),
    };

    // console.log('fetchOrderDetails in api ln 405:', orderData);

    return orderData;
};

// export const fetchOrderHistory = async (userId: number, status: string, page: number = 1, limit: number = 10, role: string) => {

//     const token = localStorage.getItem('token'); // Get the stored token
//     // console.log('fetchOrderHistory:', token,  status, page, limit);
//     // {hasRole(['super_admin', 'staff', 'technician']) && (

//     const response = await api.get(`/orders/history`, {
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//         params: {
//             user_id: userId, // Add userId to the request
//             status,
//             page,
//             limit,
//             role,
//         },
//     });

//     // console.log('fetchOrderHistory:', response, userData, token);

//     // Check if the response data is empty
//     // if (!response.data || response.data.length === 0) {
//     //     return 0;
//     // }

//     return response.data; // Adjust based on the API response structure
// };


export const fetchOrderHistory = async (
    userId: number,
    status: string,
    page: number = 1,
    limit: number = 10,
    role: string,
    search: string = '' // <-- Add search parameter with a default value
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    const response = await api.get(`/orders/history`, {
        // headers: { // Handled by interceptor
        //     Authorization: `Bearer ${token}`,
        // },
        params: {
            user_id: userId,
            status,
            page,
            limit,
            role,
            search, // <-- Include search in the API request parameters
        },
    });

    // console.log('fetchOrderHistory API call params:', { userId, status, page, limit, role, search }); // Optional: for debugging
    // console.log('fetchOrderHistory response:', response.data); // Optional: for debugging   

    return response.data;
};

export const fetchInvoiceHistory = async (
    userId: number,
    status: string,
    page: number = 1,
    limit: number = 10,
    role: string,
    search: string = '' // <-- Add search parameter with a default value
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    const response = await api.get(`/invoices/history`, {
        // headers: { // Handled by interceptor
        //     Authorization: `Bearer ${token}`,
        // },
        params: {
            user_id: userId,
            status,
            page,
            limit,
            role,
            search, // <-- Include search in the API request parameters
        },
    });

    // console.log('fetchOrderHistory API call params:', { userId, status, page, limit, role, search }); // Optional: for debugging
    // console.log('fetchInvoiceHistory response:', response.data); // Optional: for debugging   

    return response.data;
};

export const createOrder = async (payload: any) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    const url = `${API_URL}/orders`; // API_URL might be redundant if baseURL is set and this is a relative path
    // If /orders is the full path, then it's fine.
    // If API_URL is http://example.com/api and endpoint is /orders,
    // then just api.post('/orders', ...) is enough.

    const headers = {
        // Authorization: `Bearer ${token}`, // Handled by interceptor
        'Content-Type': 'application/json',
    };


    try {
        // If API_URL is the base URL of the `api` instance, this should be:
        // const response = await api.post('/orders', payload, { headers });
        // If it's a full URL different from `api.defaults.baseURL`, then `api.post(url, ...)` is correct.
        const response = await api.post(url, payload, { headers });


        // console.log('api ln 364 createOrder:', { response, payload, token });

        // return response.data;
        return response;

    } catch (error) {
        console.error("Error creating order:", error);
        throw error;
    }

};


export const updateOrder = async (orderId: number, payload: any) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    const url = `${API_URL}/orders/update/${orderId}`; // Same comment as createOrder regarding API_URL
    const headers = {
        // Authorization: `Bearer ${token}`, // Handled by interceptor
        'Content-Type': 'application/json',
    };

    // ✅ FIX: Use POST with method overriding to avoid potential CORS preflight issues with PUT.
    // The payload needs to include `_method: 'PUT'` for Laravel to correctly route it.
    const finalPayload = { ...payload, _method: 'PUT' };

    // The URL for a POST request might be different if you're not using a resource controller.
    // Assuming your backend route for updates accepts POST and respects the _method field.
    return api.post(url, finalPayload, { headers });

};

//

export const updateManualOrder = async (orderId: number, payload: any) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found');

    const url = `${API_URL}/orders/manual/update/${orderId}`; // Same comment as createOrder
    const headers = {
        // Authorization: `Bearer ${token}`, // Handled by interceptor
        'Content-Type': 'application/json',
    };

    // console.log('updateManualOrder payload:', payload);
    const finalPayload = { ...payload, _method: 'PUT' };

    return api.post(url, finalPayload, { headers });
};

export const cancelOrder = async (orderId: number) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found for cancelling order.');
    const response = await api.post(`orders/status`,
        {
            orderId: orderId,
            status: 'cancel',
            _method: 'PUT'
        },
        {
            // headers: { 'Content-Type': 'application/json' } // Auth handled by interceptor
        }
    );
    return response.data; // Assuming the API returns a success message
};

export const deleteOrder = async (orderId: number) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found for deleting order.');
    // ✅ FIX: Send a POST request with the correct payload structure for method spoofing.
    const response = await api.post(`orders/delete`, {
        orderId: orderId,
        _method: 'DELETE',
    });
    return response.data; // Assuming the API returns a success message
};

export const fetchAllCustomer = async () => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('No authentication token found for fetching all customers.');

    const response = await api.get(`customers/all-name-id`,
        {
            headers: { 'Content-Type': 'application/json' } // Auth handled by interceptor
        }
    );

    // console.log('fetchAllCustomer response:', response.data); // Optional: for debugging

    return response.data; // Assuming the API returns a success message
};


export const fetchProductsModifiers = async (
    pid: number, //product id
    add_on: number, //to list add_on products (modifier) that is product_cat = 2 (add-on)

) => {
    // Authorization header is handled by the interceptor
    // Note: This is a POST request. The interceptor adds Auth to headers.
    // Ensure backend expects token in header for POST, not body/params.
    const url = `/products/modifiers?pid=${pid}&add_on=${add_on}`;
    const response = await api.post(url, {
        // headers: { // Handled by interceptor
        //     Authorization: `Bearer ${token}`,
        // },
        // params: { // For POST, data goes in body, params in URL.
        //     pid,
        //     add_on,
        // },
    } /*, If you need to send an empty body for POST, pass {} or null */);

    // console.log('fetchProductsModifiers apip ln 501 :', response);

    return response;
};

// --- Add function to download Order PDF ---
export const downloadOrderPdf = async (orderId: number): Promise<Blob> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) {
        throw new Error('No authentication token found');
    }

    try {
        const response: AxiosResponse<Blob> = await api.get(`/orders/${orderId}/pdf`, {
            // headers: { // Handled by interceptor
            //     Authorization: `Bearer ${token}`,
            // },
            responseType: 'blob', // Important: Expect a binary response (the PDF file)
        });

        // Check if the response is actually a blob (PDF)
        if (response.data instanceof Blob && response.data.type === 'application/pdf') {
            return response.data;
        } else {
            // If the server sent an error (e.g., JSON), it might end up here
            // Try to parse it if it's JSON, otherwise throw a generic error
            if (response.data instanceof Blob && response.data.type === 'application/json') {
                const errorText = await response.data.text();
                const errorJson = JSON.parse(errorText);
                throw new Error(errorJson.message || 'Received unexpected response format instead of PDF.');
            }
            throw new Error('Received unexpected response format instead of PDF.');
        }
    } catch (error: any) {
        console.error(`Error downloading PDF for order ${orderId}:`, error);
        // Re-throw the error so the component can handle it (e.g., show toast)
        // Include response details if available
        if (error.response) {
            throw new Error(`Error downloading PDF: ${error.message || 'Unknown error'}`); // Wrap in Error object
        }
        throw error;
    }
};
// --- End PDF Download function ---


// --- Add function to send WhatsApp message via Venom Bot ---
/**
 * Sends a WhatsApp message using the venom-bot service.
 * @param phoneNumber The recipient's phone number (e.g., '601112163808').
 * @param message The text message to send.
 * @returns Promise resolving to the response from the venom-bot service.
 */
// Define an interface for the expected response (optional but good practice)
interface VenomBotResponse {
    status: string; // Or whatever structure your API returns
    message?: string;
    // ... other potential fields
}


export const sendWhatsAppMessage = async (phoneNumber: string, message: string): Promise<VenomBotResponse> => {
    // Define the URL of your venom-bot service endpoint
    const venomBotUrl = 'https://wa.u8.my/send-message'; // Consider making this configurable

    // Format the phone number as required by venom-bot
    const formattedPhoneNumber = `${phoneNumber.replace(/^\+/, '')}`;

    try {
        // console.log(`Sending WhatsApp to ${formattedPhoneNumber}: "${message}"`);

        // Make a POST request to your venom-bot service
        // This is a direct axios.post, not using the `api` instance, so no interceptors apply.
        const response = await axios.post<VenomBotResponse>(
            venomBotUrl,

            { // Specify expected request body
                // Use the key expected by the API (e.g., 'number') and the formatted value
                phone: formattedPhoneNumber,
                message: message,
            },

        );

        // console.log('WhatsApp send response:', response.data);
        return response.data;

    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
        console.error(`Error sending WhatsApp message to ${phoneNumber} (formatted as ${formattedPhoneNumber}):`, errorMessage, error.response?.data);
        // Re-throw a more informative error
        throw new Error(`Failed to send WhatsApp message: ${errorMessage}`);
    }
};
// --- End WhatsApp send function ---


// --- Add function to trigger sending order email ---
/**
 * Sends a request to the backend to email the order details.
 * @param orderId The ID of the order to email.
 * @param recipientEmail Optional: Specify a recipient email. If not provided, the backend might use the customer's email on the order.
 * @returns Promise resolving to the response from the backend API.
 */
export const sendOrderEmail = async (orderId: number, recipientEmail?: string): Promise<any> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) {
        throw new Error('No authentication token found');
    }

    // Define the backend endpoint for sending the email
    const emailEndpoint = `/orders/${orderId}/email`; // Adjust if your endpoint is different

    try {
        console.log(`Requesting email for order ${orderId}` + (recipientEmail ? ` to ${recipientEmail}` : ''));

        // Make a POST request (or GET/PUT depending on your API design)
        // Pass recipientEmail in the body if needed by the backend
        const response = await api.post(emailEndpoint,
            {
                email: recipientEmail // Send email in the body if needed
            },
            // Headers (like Content-Type) if needed, Auth is handled by interceptor
            { headers: { 'Content-Type': 'application/json' } }
        );

        // console.log('Send email response:', response.data);
        return response.data; // Return the success/status message from the backend

    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
        console.error(`Error requesting email for order ${orderId}:`, errorMessage, error.response?.data);
        throw new Error(`Failed to send order email: ${errorMessage}`);
    }
};
// --- End send order email function ---
export const sendInvoiceEmail = async (invoiceId: number, recipientEmail?: string): Promise<any> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) {
        throw new Error('No authentication token found');
    }

    // Define the backend endpoint for sending the email
    const emailEndpoint = `/invoices/${invoiceId}/email`; // Adjust if your endpoint is different

    try {
        console.log(`Requesting email for order ${invoiceId}` + (recipientEmail ? ` to ${recipientEmail}` : ''));

        // Make a POST request (or GET/PUT depending on your API design)
        // Pass recipientEmail in the body if needed by the backend
        const response = await api.post(emailEndpoint,
            {
                email: recipientEmail // Send email in the body if needed
            },
            // Headers (like Content-Type) if needed, Auth is handled by interceptor
            { headers: { 'Content-Type': 'application/json' } }
        );

        // console.log('Send email response:', response.data);
        return response.data; // Return the success/status message from the backend

    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred';
        console.error(`Error requesting email for order ${invoiceId}:`, errorMessage, error.response?.data);
        throw new Error(`Failed to send order email: ${errorMessage}`);
    }
};
// --- End send order email function ---

/**
 * Updates a specific field for a customer.
 * @param customerId - The ID of the customer to update.
 * @param field - The specific field (key) of the customer object to update.
 * @param value - The new value for the field.
 * @returns The updated customer data from the API.
 */
export const updateCustomer = async (
    customerId: string,
    field: keyof Customer,
    value: string
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) {
        console.error('Authentication token not found for updateCustomer.');
        throw new Error('Authentication required.'); // Or handle as appropriate
    }

    // Construct the payload dynamically: { fieldName: newValue }
    const payload = { [field]: value };
    // Use the relative path, as the 'api' instance should have the base URL configured
    const url = `/customers/${customerId}`;
    const finalPayload = { ...payload, _method: 'PATCH' };

    try {
        // console.log(`Attempting PATCH ${url} with payload:`, payload);
        const response = await api.post(url, finalPayload, {
            headers: {
                // Authorization: `Bearer ${token}`, // Handled by interceptor
                'Content-Type': 'application/json',
            },
        });
        // console.log(`Customer ${customerId} field ${String(field)} updated successfully:`, response.data);
        return response.data; // Return the updated data from the backend
    } catch (error: any) {
        // Log more specific error details if available
        const errorDetails = error.response?.data || error.message || error;
        console.error(`Error updating customer ${customerId} field ${String(field)}:`, errorDetails);
        // Re-throw the error so the calling component can handle it (e.g., show an alert)
        throw error;
    }
};

// --- Caching ---
let cachedLocations: ApiCountry[] | null = null;
// Use Maps for caching states/cities by their parent ID
const cachedStates = new Map<string | number, ApiState[]>();
const cachedCities = new Map<string | number, ApiCity[]>();
// --- End Caching ---

// Fetches only the list of countries
export const fetchLocations = async (): Promise<ApiCountry[]> => {
    if (cachedLocations !== null && cachedLocations.length > 0) {
        console.log('Returning cached locations (countries)');
        return cachedLocations;
    }
    try {
        // This is a GET request, interceptor will add auth if token exists.
        // If this endpoint doesn't require auth, it's fine.
        const response = await api.get('/v1/countries');
        if (response.status !== 200) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const countriesData: ApiCountry[] = response.data;
        if (!Array.isArray(countriesData)) {
            throw new Error("Invalid data format received from API for countries.");
        }
        cachedLocations = countriesData;
        // console.log('Fetched and cached locations (countries)', cachedLocations);

        return cachedLocations;
    } catch (error) {
        console.error("Failed to fetch locations (countries):", error);
        throw error;
    }
};

// Fetches states for a specific country ID
export const fetchStatesForCountry = async (countryId: string | number): Promise<ApiState[]> => {
    if (cachedStates.has(countryId)) {
        console.log(`Returning cached states for country ${countryId}`);
        return cachedStates.get(countryId)!; // Use non-null assertion as we checked with .has()
    }
    try {
        // Use the correct endpoint based on your API routes
        const response = await api.get(`/v1/countries/${countryId}/states`); // Interceptor handles auth
        if (response.status !== 200) {
            throw new Error(`HTTP error fetching states! status: ${response.status}`);
        }
        const statesData: ApiState[] = response.data; // Assuming the endpoint returns the array directly
        if (!Array.isArray(statesData)) {
            throw new Error("Invalid data format received from API for states.");
        }
        cachedStates.set(countryId, statesData); // Cache the fetched states
        // console.log(`Fetched and cached states for country ${countryId}`, statesData);
        return statesData;
    } catch (error) {
        console.error(`Failed to fetch states for country ${countryId}:`, error);
        throw error;
    }
};

// Fetches cities for a specific state ID
export const fetchCitiesForState = async (stateId: string | number): Promise<ApiCity[]> => {
    if (cachedCities.has(stateId)) {
        console.log(`Returning cached cities for state ${stateId}`);
        return cachedCities.get(stateId)!; // Use non-null assertion
    }
    try {
        // Use the correct endpoint based on your API routes
        const response = await api.get(`/v1/states/${stateId}/cities`); // Interceptor handles auth
        if (response.status !== 200) {
            throw new Error(`HTTP error fetching cities! status: ${response.status}`);
        }
        const citiesData: ApiCity[] = response.data; // Assuming the endpoint returns the array directly
        if (!Array.isArray(citiesData)) {
            throw new Error("Invalid data format received from API for cities.");
        }
        cachedCities.set(stateId, citiesData); // Cache the fetched cities
        // console.log(`Fetched and cached cities for state ${stateId}`, citiesData);
        return citiesData;
    } catch (error) {
        console.error(`Failed to fetch cities for state ${stateId}:`, error);
        throw error;
    }
};

// Assuming an endpoint like /customers/{id} exists
export const fetchCustomer = async (customerId: number): Promise<Customer> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    // Adjust URL based on your API structure
    const url = `/customers/${customerId}`;

    try {
        const response = await api.get(url); // Interceptor handles auth
        if (!response.data) { // Add check if response might be empty for not found
            throw new Error(`Customer with ID ${customerId} not found.`);
        }
        // Assuming the API returns the customer object directly
        return response.data as Customer;
    } catch (error: any) {
        console.error(`Failed to fetch customer ${customerId}:`, error.response?.data || error.message);
        throw error;
    }
};

// --- Create New User ---
interface NewUserPayload {
    name: string;
    email: string;
    phone: string; // Added phone here as it's part of userData and used in the payload
    tenant_id: string; // Frontend will generate this
    // valid_starts and valid_ends will be handled by backend
    // password?: string; // If you also send password
}

interface CreatedUserResponse extends Customer { // Assuming backend returns a user-like object with id
    id: number;
    name: string;
    email: string;
    tenant_id: string;
    // other user fields
}

export const createUser = async (userData: { name: string; email: string; phone: string; }): Promise<CreatedUserResponse> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) {
        // It's often better to throw an error that can be specifically caught,
        // or handle this in a way that prompts for login.
        throw new Error('Authentication required. Please log in.');
    }

    const payload: NewUserPayload = {
        ...userData, // userData includes name, email, and phone
        tenant_id: uuidv4(), // Generate tenant_id
    };

    try {
        const response = await api.post('/users/create', payload); // Auth handled by interceptor
        return response.data as CreatedUserResponse; // Expecting the created user object with its ID

    } catch (error: any) {
        console.error('Raw error object in createUser:', error); // Log the raw error for debugging

        // Check if it's an error with a response from the server
        if (error.response) {

            const status = error.response.status;
            const responseData = error.response.data;
            let serverMessageString = '';

            // Create a string representation of the error for searching specific keys
            if (typeof responseData === 'string') {
                serverMessageString = responseData;
            } else if (responseData && typeof responseData.message === 'string') {
                serverMessageString = responseData.message;
                // Optionally include text from validation errors if present (e.g., Laravel's errors object)
                if (responseData.errors && typeof responseData.errors === 'object') {
                    serverMessageString += ` ${JSON.stringify(responseData.errors)}`;
                }
            } else if (responseData) {
                // Fallback for other object structures, convert to string
                serverMessageString = JSON.stringify(responseData);
            }

            // Prioritized check for unique phone constraint violation
            if (serverMessageString.includes('users_phone_unique')) {
                throw new Error('Phone Number has already been taken.');
            }

            // Specifically handle 422 Unprocessable Entity (Validation errors)
            if (status === 422) {
                const validationErrors = responseData; // This is your {"email": [...]} or {"message": "...", "errors": {...}} object


                if (validationErrors && validationErrors.email && Array.isArray(validationErrors.email) && validationErrors.email.length > 0) {
                    // Throw a new error with the specific email message
                    throw new Error(validationErrors.email[0]);
                } else if (validationErrors && typeof validationErrors.message === 'string' && validationErrors.message) {
                    // Fallback for a general message if Laravel's error structure is different
                    // e.g. { "message": "Validation failed", "errors": { ... } }
                    // This will be used if the 'users_phone_unique' check didn't match and it's a 422

                    throw new Error(validationErrors.message);

                } else {
                    // Generic fallback for 422 if specific error format isn't matched
                    throw new Error('Validation failed. Please check your input.');
                }
            } else {
                // Handle other HTTP errors (e.g., 401, 403, 500)
                // If not caught by 'users_phone_unique' and not a 422
                const message = responseData?.message || error.response.statusText || `Server error: ${status}`;
                throw new Error(message);
            }
        } else if (error.request) {
            // The request was made but no response was received (e.g., network error)
            console.error('Error creating user - No response received:', error.request);
            throw new Error('Network error: No response from server.');
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error creating user - Request setup error:', error.message);
            throw new Error(error.message || 'An error occurred while setting up the request.');
        }
        // The 'throw error' from your original code is generally covered by the specific throws above.
        // If none of the conditions above are met (which is unlikely if 'error' is an actual error object),
        // this would re-throw the original error.
        // throw error; // This line might be unreachable if all paths above throw.
    }
};

// --- Create New Customer ---
interface NewCustomerPayload {
    user_id: number;
    name: string;
    active: boolean;
    // customer_uuid will be handled by backend
}

export const createCustomer = async (customerData: { user_id: number; name: string; email: string; phone: string; }): Promise<Customer> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    const payload: NewCustomerPayload = {
        ...customerData,
        active: true, // Default to active
    };

    try {
        const response = await api.post('/customers/create', payload); // Auth handled by interceptor
        return response.data as Customer;
    } catch (error: any) {
        console.error('Error creating customer:', error.response?.data || error.message);
        throw error;
    }
};

export const fetchAvailableRoles = async () => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');
    const response = await api.get('/roles'); // Adjust endpoint as needed, auth handled by interceptor
    return response.data; // e.g., ["dealer", "staff", "super_admin"]
};

export const setUserRole = async (userId: number, role: string) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');
    // Auth handled by interceptor
    const response = await api.post(`/users/${userId}/set-role`, { role });
    return response.data;
};

// abb 250606 invoice
//250405
export const convertOrderToInvoice = async (
    orderId: number,
    paymentAmount: number,
    paymentMethod: string
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post(
            `/orders/${orderId}/convert-to-invoice`,
            {
                payment_amount: paymentAmount,
                paymentMethod: paymentMethod,
            }
            // Auth handled by interceptor, headers for content-type if needed by backend
            // {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //     },
            // }
        );

        return response.data;
    } catch (error) {
        console.error('Error converting order to invoice:', error);
        throw error;
    }
};

export const orderIdGetInvoiceData = async (
    // orderUUID: string,
    orderId: number,
) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.get(
            `/orders/${orderId}` // Auth handled by interceptor
            // {
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //     },
            // }
        );

        // console.log('orderIdGetInvoiceData:', response);

        return response.data;
    } catch (error) {
        console.error('Error order id get invoice data :', error);
        throw error;
    }
};

export const fetchInvoiceDetails = async (invoiceId: number) => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.get(`/invoices/${invoiceId}`); // Auth handled by interceptor
        // {
        //     headers: {
        //         Authorization: `Bearer ${token}`,
        //     },
        // });

        // console.log('fetchInvoiceDetails ln 471:', response);

        // console.log('Raw API Response:', response.data);
        // console.log('Items Before Mapping:', response.data.items);

        // Map the response data to include modifiers
        const invoiceData = {
            ...response.data,
            items: response.data.items.map((item: any) => ({
                ...item,
                modifiers: typeof item.modifiers === 'string' ? JSON.parse(item.modifiers) : item.modifiers || [],
            })),
        };

        // console.log('Items After Mapping:', invoiceData.items);

        // console.log('fetchInvoiceDetails ln 480:', invoiceData);

        // return response.data; // Adjust based on your API response structure

        return invoiceData; // Adjust based on your API response structure

    } catch (error) {
        console.error('Error fetching invoice details:', error);
        throw error;
    }
};


// --- Create New Product Item ---
interface NewProductPayload {
    product_name: string;
    product_code?: string;
    product_cat: number; // Category ID
    product_value: number; // SRP
}

interface CreateProductResponse {
    message: string;
    product: Product;
}

export const createNewProductItem = async (payload: NewProductPayload): Promise<CreateProductResponse> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    const response = await api.post<CreateProductResponse>('/products/create', payload); // Auth handled by interceptor
    // { 
    //     headers: { Authorization: `Bearer ${token}` },
    // });

    return response.data;
};


// --- API functions for soft-deleted order items ---

// Fetches soft-deleted order items for a given order ID
export const fetchSoftDeletedOrderItems = async (orderId: number): Promise<OrderItem[]> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    const response = await api.get(`/orders/${orderId}/deleted-items`); // Auth handled by interceptor
    // { 
    //     headers: { Authorization: `Bearer ${token}` },
    // });

    // console.log('fetchSoftDeletedOrderItems response:', response.data); // Optional: for debugging

    return response.data.items; // Assuming API returns { items: OrderItem[] }
};

// Restores a soft-deleted order item by its ID
export const restoreOrderItemAPI = async (orderItemId: number): Promise<void> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');

    await api.post(`/order-items/${orderItemId}/restore`); // Auth handled by interceptor
    // { 
    //     headers: { Authorization: `Bearer ${token}` },
    // });
};

// --- Fetch Product Statuses in Bulk ---
interface ProductStatus {
    id: number;
    active: boolean;
}

export const fetchProductStatuses = async (productIds: number[]): Promise<ProductStatus[]> => {
    // Authorization header is handled by the interceptor
    if (!getAuthToken()) throw new Error('Authentication required.');
    if (productIds.length === 0) return [];

    // Assuming your backend endpoint is /products/statuses and accepts a comma-separated list of IDs
    const response = await api.get('/products/statuses', { params: { ids: productIds.join(',') } });
    return response.data; // Expects an array like [{ id: 1, active: true }, { id: 2, active: false }]
};

// In src/utils/api.ts, add this new function:

/**
 * Receives stock for a given product via /api/purchase/receive.
 * @param productId The ID of the product to receive.
 * @param quantity The quantity being received.
 * @returns A promise with the API response.
 */
export const receiveStock = async (productId: number, quantity: number): Promise<{ message: string; }> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        // Assumes you have a configured axios instance named 'api'
        const response = await api.post('/purchase/receive', {
            product_id: productId,
            quantity: quantity,
        });
        return response.data;
    } catch (error: any) {
        console.error('Error receiving stock:', error);
        // Re-throw the error to be handled by the calling component
        throw new Error(error.response?.data?.message || 'An error occurred while receiving stock.');
    }
};

export const issueStock = async (productId: number, quantity: number): Promise<{ message: string; }> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        // Assumes you have a configured axios instance named 'api'
        const response = await api.post('/invoice/issue', {
            product_id: productId,
            quantity: quantity,
        });
        return response.data;
    } catch (error: any) {
        console.error('Error issuing stock:', error);
        // Re-throw the error to be handled by the calling component
        throw new Error(error.response?.data?.message || 'An error occurred while issuing stock.');
    }
};

/**
 * Adjusts stock for a given product via /api/stock/adjust.
 * @param productId The ID of the product to adjust.
 * @param quantity The quantity to adjust by (can be positive or negative).
 * @param reason An optional reason for the adjustment.
 * @returns A promise with the API response.
 */
export const adjustStock = async (productId: number, quantity: number, reason?: string): Promise<{ message: string; }> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/stock/adjust', {
            product_id: productId,
            new_quantity: quantity,
            reason: reason,
        });
        return response.data;
    } catch (error: any) {
        console.error('Error adjusting stock:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while adjusting stock.');
    }
};

/**
 * Reserves stock for a given product via /api/stock/reserve.
 * @param productId The ID of the product to reserve.
 * @param quantity The quantity being reserved (should be positive).
 * @param reference An optional reference for the reservation (e.g., Order ID).
 * @returns A promise with the API response.
 */
export const reserveStock = async (productId: number, quantity: number, reference?: string): Promise<{ message: string; }> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/stock/reserve', {
            product_id: productId,
            quantity: quantity,
            reference: reference,
        });
        return response.data;
    } catch (error: any) {
        console.error('Error reserving stock:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while reserving stock.');
    }
};

export const releaseStock = async (productId: number, quantity: number, reference?: string): Promise<{ message: string; }> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/stock/release', {
            product_id: productId,
            quantity: quantity,
            reference: reference,
        });
        return response.data;
    } catch (error: any) {
        console.error('Error releasing stock:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while releasing stock.');
    }
};

export const fetchStocks = async (page: number = 1): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');
    try {
        const response = await api.get('/stocks', {
            params: { page },
        });
        return response.data;
    } catch (error: any) {
        console.error('Error fetching stocks:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while fetching stocks.');
    }
}


/**
 * Validates the PIN for the currently authenticated user.
 * @param pin The PIN code to validate.
 * @returns A promise with the validation result.
 */
export const validatePin = async (user_uuid: string, pin_code: string): Promise<{
    success: any; valid: boolean; message: string;
}> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/validate-pin',
            {
                pin_code: pin_code,
                user_uuid: user_uuid // Include user_id in the payload
            });

        console.log('validatePin response:', response); // Optional: for debugging

        return response.data;
    } catch (error: any) {
        console.error('Error validating PIN:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while validating the PIN.');
    }
};



// Add a type for the payload for better type safety
export interface ScanHistoryPayload {
    type: string; // The type of scan (e.g., 'qr', 'barcode')
    user_id: number; // The ID of the user performing the scan
    ts: string; // Timestamp of the scan
}

export const createScanHistory = async (payload: ScanHistoryPayload): Promise<any> => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('Authentication required.');
    }

    try {
        const response = await api.post('/scan-histories', payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        console.log('createScanHistory response:', response); // Optional: for debugging

        return response.data; // Should include the new scan_history id

    } catch (error: any) {
        console.error('Error creating scan history:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while creating scan history.');
    }
};



/**
 * Performs a stock-out action from a QR scan.
 * @param payload The data from the QR scan and the user's PIN.
 * @returns A promise with the API response.
 */
export const qrStockOut = async (payload: any): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/qr/stock-out', payload);
        return response.data;
    } catch (error: any) {
        console.error('Error during QR stock out:', error);
        throw new Error(error.response?.data?.message || 'An error occurred during stock out.');
    }

};

export const qrStockIn = async (payload: any): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/qr/stock-in', payload);
        return response.data;
    } catch (error: any) {
        console.error('Error during QR stock in:', error);
        throw new Error(error.response?.data?.message || 'An error occurred during stock in.');
    }
}

export const fetchScanHistoryList = async (payload: any): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/list-scan-histories', payload);

        // console.log('fetchScanHistoryList response:', response);

        return response.data;

    } catch (error: any) {
        console.error('Error during QR stock in:', error);
        throw new Error(error.response?.data?.message || 'An error occurred during stock in.');
    }
}

export const softDeleteScanHistory = async (scan_history_id: number): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/scan-histories/' + scan_history_id + '/soft-delete');
        return response.data;
    } catch (error: any) {
        console.error('Error during QR stock in:', error);
        throw new Error(error.response?.data?.message || 'An error occurred during soft delete {scan_history_id}.');
    }
}

export const ScanHistoryByID = async (scan_history_id: number): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/scan-history/' + scan_history_id);
        return response.data;
    } catch (error: any) {
        console.error('Error during QR stock in:', error);
        throw new Error(error.response?.data?.message || 'An error occurred during stock in.');
    }
}

export const fetchScanHistoryItemsByID = async (scan_history_id: number, movement_type: string): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post('/scan-history/' + movement_type + '/' + scan_history_id);

        // console.log('fetchScanHistoryItemsByID response:', response);

        return response.data;

    } catch (error: any) {
        console.error('Error during fetching items :', error);
        throw new Error(error.response?.data?.message || 'An error occurred during fetching items.');
    }
}

export const fetchScanHistoryByIDWithItems = async (scan_history_id: number, movement_type: string) => {
    if (!getAuthToken()) throw new Error('Authentication required.');
    try {
        const response = await api.get(`/scan-history/${movement_type}/${scan_history_id}`);
        return response.data;
    } catch (error: any) {
        console.error('Error fetching scan history with items:', error);
        throw new Error(error.response?.data?.message || 'Failed to load scan history.');
    }
};


export const fetchStockLocations = async (page: number = 1): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.get('/stock-locations', {
            params: { page },
        });

        // console.log('fetchStockLocations response:', response);

        return response.data;
    } catch (error: any) {
        console.error('Error fetching stock locations:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while fetching stock locations.');
    }
}


export const fetchLowStock = async (page: number = 1) => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.get('/low-stock', { params: { page } });

        // console.log('fetchLowStock response:', response);

        const products = Array.isArray(response.data.data)
            ? response.data.data
            : [];

        return { products };

    } catch (error: any) {
        console.error('Error fetching low stock:', error);
        throw new Error(error.response?.data?.message || 'Error fetching low stock.');
    }
};


//abb 251208 Task Reminder
export const fetchTaskReminderList = async (page: number = 1) => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.get('/v1/tasks', { params: { page } });

        // console.log('fetchTaskReminderList response:', response);

        const task_reminders = Array.isArray(response.data)
            ? response.data
            : [];

        return { task_reminders };

    } catch (error: any) {
        console.error('Error fetching task_reminders:', error);
        throw new Error(error.response?.data?.message || 'Error fetching low stock.');
    }
};

export const createTaskReminder = async (payload: any): Promise<any> => {

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        // console.log('createTaskReminder payload:', payload);

        const response = await api.post('/v1/create-tasks', payload);

        // console.log('createTaskReminder response:', response); // Optional: for debugging

        return response.data; // Should include the new task_reminder id

    } catch (error: any) {
        console.error('Error creating task reminder:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while creating task reminder.');
    }
};

export const updateTaskReminder = async (id: number, payload: Partial<TaskReminder>): Promise<any> => {
    console.log('updateTaskReminder payload:', payload);

    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        // Using PUT for a full update, or PATCH for partial.
        // Laravel resource controllers typically handle PUT on /resource/{id}.
        const response = await api.post(`/v1/tasks/update/${id}`, payload);

        console.log(`updateTaskReminder ${id} response:`, response.data); // Optional: for debugging

        return response.data;

    } catch (error: any) {
        console.error(`Error updating task reminder ${id}:`, error);
        throw new Error(error.response?.data?.message || 'An error occurred while updating the task reminder.');
    }
};

export const deleteTaskReminder = async (id: number): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        const response = await api.post(`/v1/tasks/delete/${id}`);

        console.log(`deleteTaskReminder ${id} response:`, response.data); // Optional: for debugging

        return response.data;

    } catch (error: any) {
        console.error(`Error deleting task reminder ${id}:`, error);
        throw new Error(error.response?.data?.message || 'An error occurred while deleting the task reminder.');
    }
};


// abb 251214 - TODO: call API to persist completion status, handle errors and rollback if needed
// example: await markTaskReminderComplete(id, next[id])

export const markTaskReminderComplete = async (id: number, isCompleted: boolean | number): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');
    if (typeof isCompleted !== 'boolean' && isCompleted !== 0 && isCompleted !== 1) {
        throw new Error('Invalid isCompleted value. Must be a boolean, 0, or 1.');
    }
    const status = isCompleted ? 1 : 0;
    try {
        const response = await api.post(`/v1/tasks/${id}/mark-complete/${status}`, {
            is_completed: isCompleted,
        });

        // console.log('markTaskReminderComplete response:', response); // Optional: for debugging

        return response.data;

    } catch (error: any) {
        console.error('Error marking task reminder complete:', error);
        throw new Error(error.response?.data?.message || 'An error occurred while updating task reminder status.');
    }
};

/**
 * Fetches the persisted list of WhatsApp recipients for the current user.
 * @returns A promise resolving to an array of User objects.
 */
export const fetchWhatsAppRecipients = async (): Promise<User[]> => {
    if (!getAuthToken()) throw new Error('Authentication required.');
    try {
        // Assuming the backend returns an object with a 'users' array property
        const response = await api.get('/v1/whatsapp-recipients');

        return response.data.users || [];
    } catch (error) {
        console.error('Error fetching WhatsApp recipients:', error);
        throw error;
    }
};

/**
 * Adds a user to the persisted list of WhatsApp recipients.
 * @param userId - The ID of the user to add.
 */
export const addWhatsAppRecipient = async (userId: number): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');
    try {
        return await api.post('/v1/whatsapp-recipients', { user_id: userId });
    } catch (error) {
        console.error(`Error adding WhatsApp recipient ${userId}:`, error);
        throw error;
    }
};

/**
 * Removes a user from the persisted list of WhatsApp recipients.
 * @param userId - The ID of the user to remove.
 */
export const removeWhatsAppRecipient = async (userId: number): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');
    try {
        // Use POST with method spoofing to avoid CORS preflight issues with DELETE.
        // The backend should be configured to handle this on the resource endpoint.
        return await api.post(`/v1/whatsapp-recipients/remove/${userId}`);

    } catch (error) {
        console.error(`Error removing WhatsApp recipient ${userId}:`, error);
        throw error;
    }
};

// abb 260209
/**
 * Updates the 'themes' JSON column in the c_infos table.
 * @param themes - The full themes object including your new toggles.
 */
export const updateAppThemes = async (themes: any): Promise<any> => {
    if (!getAuthToken()) throw new Error('Authentication required.');

    try {
        // We use PATCH because we are updating an existing record
        const response = await api.post('/v1/update-app-themes', {
            themes: themes,
            // _method: 'PATCH' 
        });
        
        return response.data;
    } catch (error: any) {
        console.error('Error updating app themes:', error);
        throw new Error(error.response?.data?.message || 'Failed to update settings.');
    }
};

